import React, { useEffect, useState } from 'react';
import MenuHorizontal from '../../layouts/MenuHorizontal';
import MenuVertical from '../../layouts/MenuVertical';
import { useDispatch } from 'react-redux';
import { Icon } from 'semantic-ui-react';
import Erro from '../../layouts/mensagens/Erro';
import { Link, Redirect } from 'react-router-dom';
import { updateUsuario } from '../../../actions/auth';
import api from '../../../api';
import './Pagamento.css';

const PagamentoSucesso = ({ match }) => {
  const dispatch = useDispatch();

  const [condominio, setCondominio] = useState({});
  const [errors, setErrors] = useState({});

  useEffect(() => {
    const init = async () => {
      try {
        setCondominio(await api.condominio.findSimpleById(match.params.id));
      } catch (e) {
        setErrors((e.data && e.data.errors) || {});
      }
      dispatch(updateUsuario());
    };
    init();
  }, [dispatch, match.params.id]);

  return (
    <div>
      {!!errors.global && <Redirect to="/" />}
      <MenuHorizontal />
      <div className="corpo-dashboard">
        <MenuVertical condominio={condominio} />
        <div className="va-checkout">
          <ol className="va-stepper">
            {[['Plano', 'tags'], ['Unidades', 'building'], ['Pagamento', 'credit card'], ['Concluído', 'flag checkered']].map(([label, icon], i) => (
              <li key={label} className={i < 3 ? 'done' : 'active'}>
                <span className="va-stepper-bolha"><Icon name={i < 3 ? 'check' : icon} /></span>
                <span className="va-stepper-label">{label}</span>
              </li>
            ))}
          </ol>
          <Erro text={errors.error} tipo="block" />
          <div className="va-checkout-main va-sucesso">
            <div className="va-sucesso-icone"><Icon name="check" /></div>
            <h2>Pagamento confirmado!</h2>
            <p className="va-sub">
              Seu condomínio{condominio.nome ? <b> {condominio.nome}</b> : ''} está ativo.
              Um e-mail de confirmação foi enviado para você.
            </p>
            <div className="va-sucesso-proximos">
              <h4>Próximos passos</h4>
              <Link to={`/condominios/${condominio._id}/unidades/cadastrar`}><Icon name="home" /> Cadastrar unidades votantes</Link>
              <Link to={`/condominios/${condominio._id}/votacoes/cadastrar`}><Icon name="calendar check" /> Criar a primeira votação</Link>
              <Link to={`/condominios/${condominio._id}/historico`}><Icon name="clipboard list" /> Ver histórico de pagamentos</Link>
            </div>
            <Link to={`/condominios/${condominio._id}`} className="ui button btn-ui-1 large">
              Ir para a visão geral <Icon name="arrow right" />
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PagamentoSucesso;
